// extracted by mini-css-extract-plugin
module.exports = {"paper":"paper-2NoBk","button":"button-sYDtf"};